export default "__VITE_ASSET__BLNsxu4I__"